export function daysBetween(a, b) {
  if (!a || !b) return 0
  return Math.round((new Date(b) - new Date(a)) / 86400000)
}

export function calcSellerDays(row) {
  if (!row.calc || !row.calc.periodStart || !row.calc.transferDate) return 0
  return daysBetween(row.calc.periodStart, row.calc.transferDate) + 1
}

export function calcBuyerDays(row) {
  if (!row.calc || !row.calc.periodEnd || !row.calc.transferDate) return 0
  return daysBetween(row.calc.transferDate, row.calc.periodEnd)
}

export function calcTotalDays(row) {
  return calcSellerDays(row) + calcBuyerDays(row)
}

export function calcRatePerDay(row) {
  const totalDays = calcTotalDays(row)
  if (!totalDays || !row.calc) return 0
  return Number(row.calc.totalFee || 0) / totalDays
}

export function calcSellerAmount(row) {
  return Math.round(calcSellerDays(row) * calcRatePerDay(row))
}

export function calcBuyerAmount(row) {
  return Math.round(calcBuyerDays(row) * calcRatePerDay(row))
}
